import { http } from '../client';
import type { CallOptions, WriteOptions } from '../types';
import type { PostOperationsApi } from './postOperations';

// Paths mirror subsystems/identity/facade/adapters/admin-api/src/admin/post_operations.rs.
const rd = (o?: CallOptions) => ({ signal: o?.signal });
const wr = (o?: WriteOptions) => ({ signal: o?.signal, idempotencyKey: o?.idempotencyKey });

export const postOperationsHttp: PostOperationsApi = {
  listPostOperations: (query, opts) => http.get('api', '/compliance/post-operations', { query: { ...query }, ...rd(opts) }),
  getComplianceRequirements: (opts) => http.get('api', '/compliance/requirements', rd(opts)),
  backfillPostOperations: (body, opts) => http.post('api', '/compliance/post-operations/backfill', body, wr(opts)),
  listSignatureQueue: (query, opts) => http.get('api', '/compliance/registrar-signature/queue', { query: { ...query }, ...rd(opts) }),
  listSignatureBatches: (opts) => http.get('api', '/compliance/registrar-signature/batches', rd(opts)),
  signQueuedNow: (scope, opts) => http.post('api', '/compliance/registrar-signature/batches', scope, wr(opts)),
  updateSignatureSettings: (body, opts) => http.put('api', '/compliance/registrar-signature/settings', body, wr(opts)),
  listTrackingReports: (query, opts) => http.get('api', '/compliance/domain-tracking-reports', { query: { ...query }, ...rd(opts) }),
  previewTrackingReport: (date, opts) => http.get('api', '/compliance/domain-tracking-reports/preview', { query: { date }, ...rd(opts) }),
  sendTrackingReport: (date, opts) => http.post('api', `/compliance/domain-tracking-reports/${encodeURIComponent(date)}/send`, {}, wr(opts)),
};
